import React from 'react';
import PropTypes from 'prop-types';
import Font from '@mui/icons-material/HowToReg';
import { Card, Typography, IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Grid, Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import ApprovalTypeLevelEmployeeListItemComponent from './ApprovalTypeLevelEmployeeListItemComponent';
import { getErrors } from '@totalsoft/pure-validations-react';

const ApprovalTypeLevelEmployeeListComponent = ({ approvalTypeLevelEmployees, dispatch, employees, validation }) => {
  const { t } = useTranslation();
  const onAdd = collection => {
    const key = 'approvalTypeEmployeeId';

    dispatch({
      type: 'onAddApprovalTypeEmployee',
      key,
      collection
    });
  };
  const onDeleteApprovalTypeLevelEmployee = (collection, key, index) => {
    if (window.confirm(t('ApprovalTypes.ApprovalTypeLevelEmployee.DeleteEmployee'))) {
      if (approvalTypeLevelEmployees[index].isDefault) onHeaderPropertyChanged('defaultEmployeeName', ' ');

      dispatch({
        type: 'onDeleteItemCollection',
        collection,
        key,
        index
      });
    }
  };

  const onHeaderPropertyChanged = (propertyName, value) => {
    dispatch({ type: 'OnHeaderPropertyChanged', propertyName, value });
  };

  return (
    <Card
      icon={Font}
      iconColor='primary'
      title={t('ApprovalTypes.ApprovalTypeLevelEmployee.GeneralData')}
      subheader={<Typography color='error'>{validation |> getErrors}</Typography>}
      actions={
        <IconButton
          type='add'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.Add')}
          onClick={() => {
            onAdd('approvalTypeEmployees');
          }}
        />
      }
    >
      <Grid item>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('ApprovalTypes.ApprovalTypeLevelEmployee.Employee')}</TableCell>
              <TableCell>{t('ApprovalTypes.ApprovalTypeLevelEmployee.Default')}</TableCell>
              <TableCell align='right'>{t('ApprovalTypes.ApprovalTypeLevelEmployee.Actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {approvalTypeLevelEmployees.map((item, idx) => {
              return (
                <ApprovalTypeLevelEmployeeListItemComponent
                  item={item}
                  key={idx}
                  index={idx}
                  dispatch={dispatch}
                  employees={employees}
                  onDelete={onDeleteApprovalTypeLevelEmployee}
                  validation={validation[idx]}
                />
              );
            })}
          </TableBody>
        </Table>
      </Grid>
    </Card>
  );
};

ApprovalTypeLevelEmployeeListComponent.propTypes = {
  approvalTypeLevelEmployees: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired
};

export default ApprovalTypeLevelEmployeeListComponent;
